import Cookie from 'js-cookie';

export function tokenHeader() {
    let token = Cookie.get('auth_token');
    console.log(token)

    if(token){
        return {headers: {authorization: `Token ${token}`}};
    }else{
        token = localStorage.getItem('TOKEN');
    }

    return token ? {headers: {authorization: `Token ${token}`}}: {};
}


// WEBPACK FOOTER //
// ./src/utils/headers.js